import Indicator, { IndicatorType } from '../types/Indicator'

const Close: Indicator = {
  type: IndicatorType.PRICE,
  value: 'close',
  label: 'Close/Current',
  fields: ['close'],
}

export default Close
